import React, { useEffect, useState } from "react";
import { Modal, Alert, Typography, Space, Card } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import controleAbasService from "../../services/TabControlService";

const { Text, Title } = Typography;

const MaxTabsWarningModal = () => {
	const [visible, setVisible] = useState(false);

	useEffect(() => {
		const verificarAviso = () => {
			const deveMostrar = controleAbasService.deveMostrarAviso();
			setVisible(deveMostrar);
		};

		verificarAviso();

		controleAbasService.adicionarObservador(verificarAviso);

		const intervalo = setInterval(verificarAviso, 2000);

		return () => {
			controleAbasService.removerObservador(verificarAviso);
			clearInterval(intervalo);
		};
	}, []);

	const handleOk = () => {
		if (controleAbasService.deveMostrarAviso()) {
			return;
		}
		setVisible(false);
	};

	const handleCancel = () => {
		if (controleAbasService.deveMostrarAviso()) {
			return;
		}
		setVisible(false);
	};

	const renderHeader = () => (
		<Space align="center" size="middle">
			<ExclamationCircleOutlined
				style={{
					color: "#ffffff",
					fontSize: "24px",
				}}
			/>
			<Title
				level={4}
				style={{
					color: "#ffffff",
					margin: 0,
					fontWeight: "600",
				}}
			>
				Limite de Abas Atingido
			</Title>
		</Space>
	);

	const renderInstructions = () => (
		<Card
			style={{
				background: "#fff3cd",
				borderRadius: "8px",
				marginBottom: "20px",
			}}
			bodyStyle={{ padding: "20px" }}
		>
			<Text strong style={{ color: "#000", fontSize: "15px" }}>
				Para continuar:
			</Text>
			<Space
				direction="vertical"
				style={{ width: "100%", marginTop: "8px" }}
			>
				<Text style={{ color: "#000000", fontSize: "15px" }}>
					• Feche uma das abas abertas
				</Text>
				<Text style={{ color: "#000000", fontSize: "15px" }}>
					• Ou recarregue esta página após fechar uma aba
				</Text>
				<Text style={{ color: "#000000", fontSize: "15px" }}>
					• Se já fechou todas as abas e o aviso continua aparecendo,
					aguarde 1 minuto e tente novamente.
				</Text>
			</Space>
		</Card>
	);

	const renderActiveTabs = () => (
		<Card
			style={{
				background: "#fff3cd",
				borderRadius: "8px",
			}}
			bodyStyle={{ padding: "16px", textAlign: "center" }}
		>
			<Text strong style={{ color: "#000", fontSize: "18px" }}>
				Abas ativas: {controleAbasService.contarAbas()}/
				{controleAbasService.maximoAbas}
			</Text>
		</Card>
	);

	return (
		<Modal
			title={renderHeader()}
			open={visible}
			onOk={handleOk}
			onCancel={handleCancel}
			closable={false}
			maskClosable={false}
			okButtonProps={{ style: { display: "none" } }}
			cancelButtonProps={{ style: { display: "none" } }}
			width={600}
			centered
			bodyStyle={{ padding: "32px" }}
			styles={{
				header: {
					background: "#ffc107",
					margin: "-24px -24px 0 -24px",
					padding: "20px 24px",
					borderRadius: "8px 8px 0 0",
				},
			}}
		>
			<Space direction="vertical" size="large" style={{ width: "100%" }}>
				<Alert
					message={`Você já possui ${controleAbasService.maximoAbas} abas abertas simultaneamente.`}
					description={
						<Text
							style={{
								color: "#000000",
								fontSize: "15px",
								lineHeight: "1.5",
							}}
						>
							Por questões de segurança e performance, é permitido
							abrir no máximo {controleAbasService.maximoAbas}{" "}
							abas por vez.
						</Text>
					}
					showIcon={false}
					style={{
						border: "none",
						background: "transparent",
					}}
				/>

				{renderInstructions()}
				{renderActiveTabs()}
			</Space>
		</Modal>
	);
};

export default MaxTabsWarningModal;
